import { Action } from '@ngrx/store';

export const DISABLE = '[GO-SUITE:DISABLED] DISABLE';
export const ENABLE = '[GO-SUITE:DISABLED] ENABLE';

export class DisableAction implements Action {
	readonly type = DISABLE;

	constructor(public app: string|string[]) {}
}

export class EnableAction implements Action {
	readonly type = ENABLE;

	constructor(public app: string|string[]) {}
}

export type All
	= DisableAction
	| EnableAction;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/disabled.ts